<template>
	<div class="menu">
		<div class="menu-profile text-center">
			<img src="~@/assets/img/logo.png" class="img-fluid">
			<!--<a href="javascript:;" class="menu-profile-link">
				<div class="menu-profile-cover with-shadow"></div>
				<div class="menu-profile-image menu-profile-image-icon bg-gray-900 text-gray-600">
					<i class="fa fa-user"></i>
				</div>
				<div class="menu-profile-info">
					<div class="d-flex align-items-center">
						<div class="flex-grow-1" v-if="user != null">
							{{user.name}}
						</div>
						<div class="menu-caret ms-auto"></div>
					</div>
				</div>
			</a>-->
		</div>
		<div id="appSidebarProfileMenu" class="collapse"  v-bind:class="{ 'd-block': this.stat == 'expand' && !this.appOptions.pageSidebarMinified, 'd-none': this.stat == 'collapse' }">
			<div class="menu-item">
				<router-link to="/profile" class="menu-link pt-5px">
					<div class="menu-icon"><i class="fa fa-user"></i></div>
					<div class="menu-text"> Profile</div>
				</router-link>
			</div>
			<div class="menu-divider m-0"></div>
		</div>
	</div>
</template>

<script>
import AppOptions from '../../config/AppOptions.vue'

export default {
	name: 'SidebarNavProfile',
	data() {
		return {
			stat: '',
			appOptions: AppOptions
		}
	},
	computed:{
		user(){
			return this.$store.state.user;
		}
	},
	methods: {
		expand: function() {
			this.stat = (this.stat == 'expand') ? 'collapse' : 'expand'
		}
  }
}
</script>
